import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { AccordionAccountholderVM, PracticeDetailVM } from 'practice/view-models/practice-detail';
import Form from './form';
import ItalianForeignStateDocument from 'front-office/components/shared/generality/release-card/italian-foreign-state-document';
import { noop } from 'shell/utils/noop';

interface AccordionAccountholderProps {
  disabled?: boolean;
}

const AccordionAccountholderComponent = ({
  disabled = false,
}: AccordionAccountholderProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<PracticeDetailVM>();

  const onChange = useEventCallback(
    (
      key: keyof AccordionAccountholderVM,
      value: AccordionAccountholderVM[keyof AccordionAccountholderVM]
    ) => {
      formContext.setFieldValue('accountholder', {
        ...(formContext.values.accountholder || {}),
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-accountholder-content"
        id="accordion-accountholder-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Intestatario</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form onChange={onChange} disabled={disabled} values={formContext.values.accountholder} />
        {formContext.values.practice?.flagApplicant !== '1' ? (
          <ItalianForeignStateDocument
            isForeign={formContext.values.applicant?.isForeignDocument}
            values={formContext.values.applicant}
            onChange={noop}
            onChangeValues={noop}
            disabled
          />
        ) : undefined}
      </AccordionDetails>
    </Accordion>
  );
};

AccordionAccountholderComponent.displayName = 'Practice Detail - Form - accordion accountholder';

const AccordionAccountholder = memo(AccordionAccountholderComponent);

export default AccordionAccountholder;
